import { atom, selector, selectorFamily } from "recoil";

export const currentUser = atom({
  key: "app_currentUser",
  default: {},
});

export const appBrandDetails = atom({
  key: "appBrandDetails",
  default: {},
});

export const APP_CONTROLLER_ACTIONS = {
  BRAND_DETAILS: "BRAND_DETAILS",
  PAYMENT_TERMS: "PAYMENT_TERMS",
};

export const appPaymentTerms = atom({
  key: "appPaymentTerms",
  default: {},
});

export const appStateController = selectorFamily({
  key: "appStateController",
  set:
    () =>
    ({ get, set }, { action, payload }) => {
      switch (action) {
        case APP_CONTROLLER_ACTIONS.BRAND_DETAILS:
          console.log("payload", payload);
          set(appBrandDetails, payload);
          break;
        case APP_CONTROLLER_ACTIONS.PAYMENT_TERMS:
          console.log("paymentTerms", payload);
          set(appPaymentTerms, payload);
          break;
        default:
          break;
      }
    },
});

export const modalAtom = atom({
  key: "modal",
  default: {
    title: "",
    content: null,
  },
});

export const domainListAtom = atom({
  key: "domainList",
  default: {
    trader_company_id: null,
    domains: [],
  },
});
